<div class="actions-container">
  <ng-casto-button [label]="'need_mapping.no_choice.info'|translate" class="secondary"
                   (click)="selectOvenConfiguration('')"></ng-casto-button>
</div>
<ul class="inspiration-items">
  @for (ovenConfiguration of datas.ovenConfigurations; track ovenConfiguration) {
    <li
      [class.active]="current.kitchen.ovenConfigurationRef === ovenConfiguration.id"
    >
      <figure (click)="selectOvenConfiguration(ovenConfiguration.id)">
      <span class="media padding">
        <img
          class="vertical"
          [src]="'assets/img/' + ovenConfiguration.img"
          [alt]="ovenConfiguration.titleRef | translate" />
        <span class="title-overlay">
   {{ ovenConfiguration.titleRef | translate }}
  </span>
        <span class="state">
          <svg class="icon-action-select-thumb" aria-hidden="true">
            <use
              xmlns:xlink="http://www.w3.org/1999/xlink"
              xlink:href="assets/img/icons.svg#icon-action-select-thumb"></use>
          </svg>
        </span>
      </span>
      </figure>
    </li>
  }
</ul>
